<template>
  <div>
    <!-- <p style="text-align: center;" v-if="loading">Loading...</p> -->
    <transition name='fade' mode="out-in">
      <a class="button is-link is-loading is-large is-fullwidth" v-if="loading && !finished" key="loading">Loading</a>
      <div v-if="finished" key="finished">
        <h3 style="text-align: center;">Validating...</h3>
        <p style="text-align: center;">We're making sure we can talk to your bank. This can take a minute or two.</p>
        <p style="text-align: center;">While you wait, see why our customers love working with us:</p>
        <transition name='slide' mode="out-in">
          <div class="tile is-parent" style="max-width: 500px; margin: auto; margin-bottom: 30px;" :key="reviewIndex">
            <article class="tile is-child box" style="">
              <div class="content">
                <p style="text-align: center;">{{reviews[reviewIndex].message}}</p>
                <h4 style="text-align: center; margin-top: 0px; margin-bottom: 0px;">{{reviews[reviewIndex].name}}</h4>
                <img src="../../../../src/assets/img/star.png" id="stars">
              </div>
            </article>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Finicity',
  components: {
  },
  props: {
    api: String
  },
  data () {
    return {
      loading: true,
      finished: false,
      customerId: null,
      finresult: false,
      reviews: [{name: 'Chad Smith', message: 'These guys were great to work with in obtaining financing for our mobile truck business, which is a very specialized and difficult niche to get a loan for. Everyone we worked with was professional, knowledgeable, corteous, and efficient. They expedited our needs and we were able to meet the deadline for our first event!'}, {name: 'Bo Burgarello', message: 'I worked with Jerry Stone on a used truck deal. He couldn\'t have been better to work with for me and the customer. I would recommend anyone looking for financing to reach out to Jerry at Cardiff.'}, {name: 'Melissa Racquel Bacelar', message: 'I worked with Thomas Murphy. He was very communicative, easy to work with and the loan happened super quickly. My credit is not great so I was very appreciative for all his help. I would absolutely work with him again.'}, {name: 'Eric Goldberg', message: 'Ryan and Denis are first class. They helped us get financing when we had no other options. If you\'re looking to expand, revamp, or start your business, you NEED to give them a call.'}, {name: 'Crissy Hensley', message: 'Worked with Sal and Mitch for some business funding. Process was simple from start to finish. Would recommend and will use again in the future.'}, {name: 'Robert Kirchner', message: 'This company was very professional and courteous. And quick on the funding I asked for. I would recommend this company to anyone I know in business that needs funding for their business. Thanks again'}],
      reviewIndex: 0,
      obj: 'financials',
      inputs: {
        customerId: ''
      },
    }
  },
  mounted: function () {
    var self = this
    if (self.finished) {
      // testing - set finished to true
      setInterval(function () {
        self.reviewIndex++
      }, 8000)
      return
    }
    console.log(self.api)
    $.ajax({
      type: 'POST',
      url: '/api/' + self.api + '/get-finicity-link',
      contentType: 'application/json',
      dataType: 'json'
    }).done(function (apidata) {
      if (apidata.link) {
        console.log(apidata.link)
        window.finicityConnect.connectIFrame(apidata.link, {
          selector: '#connect-container',
          overlay: 'rgba(255,255,255, 0)',
          success: function (resp) {
            console.log('Yay!', resp)
            self.finished = true
            self.customerId = apidata.custid
            self.inputs.customerId = apidata.custid
            setInterval(function () {
              if (self.reviewIndex >= self.reviews.length - 1) {
                self.reviewIndex = 0
              } else {
                self.reviewIndex++
              }
            }, 8000)
            $.ajax({
              type: 'POST',
              url: '/api/' + self.api + '/refresh-finicity-customer',
              contentType: 'application/json',
              dataType: 'json',
              data: JSON.stringify({ customerId: apidata.custid })
            }).done(function (response) {
              console.log('Yay, done!!', response)
              self.finresult = true
              self.next()
            }).fail(function (err) {
              self.next()
              console.log(err)
            })
          },
          cancel: function () {
            self.next()
          },
          error: function (err) {
            console.log(err)
            self.next()
          },
          loaded: function () {
            console.log('loaded')
            self.loading = false
          }
        })
      }
    }).fail(function (err) {
      console.log(err)
    })
  },
  methods: {
    next () {
      console.log('I IN FINICITY :D')
      this.$emit('next', this.$data)
      console.log(this.$data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#stars {
  max-width: 40%;
  margin: auto;
  display: block;
}
</style>
